import { EInvoicesClient } from "./version3Clients/EInvoicesClient";
import { WorkflowStatusClient } from "./version3Clients/WorkflowStatusClient";

export const eInvoicesClient = new EInvoicesClient();
export const workflowStatusClient = new WorkflowStatusClient();
